import React, { useEffect } from 'react';

const StructuredData = () => {
    useEffect(() => {
        // Organization Schema
        const organizationSchema = {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "MehareTech Solutions",
            "alternateName": "MehareTech",
            "url": "https://meharetech.com",
            "logo": "https://meharetech.com/images/logo-meharetech.png",
            "description": "Premier IT Services & Software Development company specializing in web development, mobile apps, cloud solutions, and digital marketing since 2012.",
            "foundingDate": "2012",
            "founders": [
                {
                    "@type": "Person",
                    "name": "MehareTech Team"
                }
            ],
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "420, Sundar Nagar",
                "addressLocality": "Hisar",
                "addressRegion": "Haryana",
                "postalCode": "125001",
                "addressCountry": "IN"
            },
            "contactPoint": [
                {
                    "@type": "ContactPoint",
                    "telephone": "+91-8708604830",
                    "contactType": "customer service",
                    "email": "meharetech@gmail.com",
                    "areaServed": "IN",
                    "availableLanguage": ["en", "hi"]
                }
            ],
            "sameAs": [
                "https://www.instagram.com/meharetech_/",
                "https://www.linkedin.com/company/meharetech",
                "https://www.facebook.com/meharetech",
                "https://twitter.com/meharetech"
            ],
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.9",
                "reviewCount": "150",
                "bestRating": "5",
                "worstRating": "1"
            }
        };

        // Local Business Schema
        const localBusinessSchema = {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "MehareTech Solutions",
            "image": "https://meharetech.com/images/logo-meharetech.png",
            "@id": "https://meharetech.com",
            "url": "https://meharetech.com",
            "telephone": "+91-8708604830",
            "priceRange": "$$",
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "420, Sundar Nagar",
                "addressLocality": "Hisar",
                "addressRegion": "Haryana",
                "postalCode": "125001",
                "addressCountry": "IN"
            },
            "geo": {
                "@type": "GeoCoordinates",
                "latitude": 29.1492,
                "longitude": 75.7217
            },
            "openingHoursSpecification": {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday"
                ],
                "opens": "10:00",
                "closes": "19:00"
            }
        };

        // Service Schema
        const serviceSchema = {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "IT Services & Software Development",
            "provider": {
                "@type": "Organization",
                "name": "MehareTech Solutions"
            },
            "areaServed": {
                "@type": "Country",
                "name": "India"
            },
            "hasOfferCatalog": {
                "@type": "OfferCatalog",
                "name": "IT Services",
                "itemListElement": [
                    {
                        "@type": "Offer",
                        "itemOffered": {
                            "@type": "Service",
                            "name": "Website Development",
                            "description": "Custom web development using React, Next.js, and modern frameworks"
                        }
                    },
                    {
                        "@type": "Offer",
                        "itemOffered": {
                            "@type": "Service",
                            "name": "Mobile App Development",
                            "description": "Native and cross-platform mobile applications"
                        }
                    },
                    {
                        "@type": "Offer",
                        "itemOffered": {
                            "@type": "Service",
                            "name": "Digital Marketing",
                            "description": "SEO, PPC, and social media marketing services"
                        }
                    },
                    {
                        "@type": "Offer",
                        "itemOffered": {
                            "@type": "Service",
                            "name": "Cloud Solutions",
                            "description": "Cloud infrastructure and migration services"
                        }
                    }
                ]
            }
        };

        // Breadcrumb Schema (dynamic based on current path)
        const getBreadcrumbSchema = () => {
            const path = window.location.pathname;
            const pathParts = path.split('/').filter(Boolean);

            const itemListElement = [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://meharetech.com"
                }
            ];

            let currentUrl = "https://meharetech.com";
            pathParts.forEach((part, index) => {
                currentUrl += `/${part}`;
                itemListElement.push({
                    "@type": "ListItem",
                    "position": index + 2,
                    "name": part.charAt(0).toUpperCase() + part.slice(1).replace(/-/g, ' '),
                    "item": currentUrl
                });
            });

            return {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": itemListElement
            };
        };

        // Inject all schemas
        const schemas = [
            organizationSchema,
            localBusinessSchema,
            serviceSchema,
            getBreadcrumbSchema()
        ];

        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.text = JSON.stringify(schemas);
        script.id = 'global-structured-data';

        // Remove existing script if present
        const existingScript = document.getElementById('global-structured-data');
        if (existingScript) {
            existingScript.remove();
        }

        document.head.appendChild(script);

        return () => {
            const scriptToRemove = document.getElementById('global-structured-data');
            if (scriptToRemove) {
                scriptToRemove.remove();
            }
        };
    }, []);

    return null;
};

export default StructuredData;
